export const fixTicker = (symbol) => {
  let tckr = symbol;

  if(symbol.indexOf('.') > -1) {
    tckr = symbol.replace(/\./, '-');
  }

  return tckr;
}